import { render, staticRenderFns } from "./FileLoader.vue?vue&type=template&id=66974cec&scoped=true&"
import script from "./FileLoader.vue?vue&type=script&lang=js&"
export * from "./FileLoader.vue?vue&type=script&lang=js&"
import style0 from "./FileLoader.vue?vue&type=style&index=0&id=66974cec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66974cec",
  null
  
)

export default component.exports